import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

export const PageHeader = ({ title, subtitle, actions, testId }) => (
  <div className="mb-8 flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between fade-up" data-testid={testId}>
    <div>
      <h1 className="text-2xl font-bold tracking-tight sm:text-3xl">{title}</h1>
      {subtitle && <p className="mt-1.5 text-sm text-muted-foreground">{subtitle}</p>}
    </div>
    {actions && <div className="flex flex-wrap gap-2">{actions}</div>}
  </div>
);

const STATUS = {
  pending: ["In attesa", "bg-amber-100 text-amber-800 dark:bg-amber-500/15 dark:text-amber-300"],
  approved: ["Approvata", "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300"],
  rejected: ["Rifiutata", "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300"],
  cancelled: ["Annullata", "bg-neutral-200 text-neutral-600 dark:bg-neutral-700 dark:text-neutral-300"],
  revoked: ["Revocata", "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300"],
  submitted: ["Inviata", "bg-sky-100 text-sky-800 dark:bg-sky-500/15 dark:text-sky-300"],
  acknowledged: ["Presa visione", "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300"],
  accepted: ["Accettato", "bg-emerald-100 text-emerald-800 dark:bg-emerald-500/15 dark:text-emerald-300"],
  declined: ["Rifiutato", "bg-red-100 text-red-700 dark:bg-red-500/15 dark:text-red-300"],
};

export const StatusBadge = ({ status, testId }) => {
  const [label, cls] = STATUS[status] || [status, "bg-muted"];
  return (
    <span data-testid={testId} className={cn("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", cls)}>
      {label}
    </span>
  );
};

export const StatCard = ({ label, value, icon: Icon, hint, to, testId, accent }) => {
  const body = (
    <div className={cn("lift h-full rounded-lg border bg-card p-5", accent && "border-primary/40")} data-testid={testId}>
      <div className="flex items-start justify-between">
        <p className="text-xs font-medium uppercase tracking-wider text-muted-foreground">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-primary" />}
      </div>
      <p className="font-display mt-3 text-3xl font-bold">{value}</p>
      {hint && <p className="mt-1 text-xs text-muted-foreground">{hint}</p>}
    </div>
  );
  return to ? <Link to={to} className="block">{body}</Link> : body;
};

export const Empty = ({ icon: Icon, text, testId }) => (
  <div className="flex flex-col items-center justify-center rounded-lg border border-dashed bg-card/50 px-6 py-14 text-center" data-testid={testId}>
    {Icon && <Icon className="mb-3 h-8 w-8 text-muted-foreground/60" />}
    <p className="text-sm text-muted-foreground">{text}</p>
  </div>
);

export const Panel = ({ title, action, children, className, testId }) => (
  <section className={cn("rounded-lg border bg-card", className)} data-testid={testId}>
    {title && (
      <div className="flex items-center justify-between border-b px-5 py-3.5">
        <h2 className="text-sm font-semibold">{title}</h2>
        {action}
      </div>
    )}
    {children}
  </section>
);
